export enum AccessPermissionsTableColumnSizes {
  GroupName = 16,
}
